import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["menu"]
  static values = { 
    hover: { type: Boolean, default: true },
    delay: { type: Number, default: 300 }
  }

  connect() {
    this.isOpen = false
    this.hoverTimeout = null
    this.setupEventListeners()
  }

  disconnect() {
    this.removeEventListeners()
  }

  setupEventListeners() {
    if (this.hoverValue) {
      this.element.addEventListener('mouseenter', this.showMenu.bind(this))
      this.element.addEventListener('mouseleave', this.hideMenu.bind(this))
    }
    
    // Click events for mobile/touch devices - only on the toggle button
    const toggleButton = this.element.querySelector('.dropdown-toggle')
    if (toggleButton) {
      toggleButton.addEventListener('click', this.toggleMenu.bind(this))
    }
    
    // Close dropdown when clicking outside
    document.addEventListener('click', this.handleOutsideClick.bind(this))
  }

  removeEventListeners() {
    if (this.hoverValue) {
      this.element.removeEventListener('mouseenter', this.showMenu.bind(this))
      this.element.removeEventListener('mouseleave', this.hideMenu.bind(this))
    }
    
    const toggleButton = this.element.querySelector('.dropdown-toggle')
    if (toggleButton) {
      toggleButton.removeEventListener('click', this.toggleMenu.bind(this))
    }
    
    document.removeEventListener('click', this.handleOutsideClick.bind(this))
  }

  showMenu() {
    if (this.hoverTimeout) {
      clearTimeout(this.hoverTimeout)
    }
    
    this.hoverTimeout = setTimeout(() => {
      this.menuTarget.classList.add('show')
      this.isOpen = true
    }, 100)
  }

  hideMenu() {
    this.hoverTimeout = setTimeout(() => {
      this.menuTarget.classList.remove('show')
      this.isOpen = false
    }, this.delayValue)
  }

  toggleMenu(event) {
    event.preventDefault()
    event.stopPropagation()
    
    if (this.isOpen) {
      this.hideMenu()
    } else {
      this.showMenu()
    }
  }

  handleOutsideClick(event) {
    if (!this.element.contains(event.target)) {
      this.menuTarget.classList.remove('show')
      this.isOpen = false
    }
  }

  // Close dropdown when a menu item is clicked
  closeMenu() {
    this.menuTarget.classList.remove('show')
    this.isOpen = false
  }

  // Handle menu item clicks
  handleMenuItemClick(event) {
    this.closeMenu()
  }
}
